<div class="appointments-container py-4 px-3">
  
  <!-- Header de Agenda -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h2 class="fw-bold mb-0"><i class="bi bi-calendar3 me-2 text-primary"></i>Agenda de Citas</h2>
      <p class="text-muted mb-0">Gestiona las entradas futuras al taller</p>
    </div>
    <button class="btn btn-primary shadow-sm" (click)="openModal()">
      <i class="bi bi-plus-lg me-1"></i> Agendar Cita
    </button>
  </div>

  <!-- Selector de Fecha Semanal -->
  <div class="card border-0 shadow-sm mb-4 overflow-hidden rounded-16">
    <div class="d-flex justify-content-between align-items-center p-3 bg-white border-bottom">
      <h5 class="mb-0 fw-bold">{{ selectedDate | date:'MMMM yyyy' | uppercase }}</h5>
      <div class="btn-group">
        <button class="btn btn-outline-secondary btn-sm" (click)="selectDay(weekDays[0])"><i class="bi bi-chevron-left"></i> Anterior</button>
        <button class="btn btn-outline-primary btn-sm" (click)="selectDay(selectedDate)">Hoy</button>
        <button class="btn btn-outline-secondary btn-sm" (click)="selectDay(weekDays[6])">Siguiente <i class="bi bi-chevron-right"></i></button>
      </div>
    </div>
    <div class="d-flex bg-light text-center p-2 calendar-week">
      <div *ngFor="let day of weekDays" 
           class="flex-grow-1 calendar-day-col py-2" 
           [class.active]="day.getTime() === selectedDate.getTime()"
           [class.is-today]="isToday(day)"
           (click)="selectDay(day)">
        <div class="small text-muted text-uppercase">{{ day | date:'EEE' }}</div>
        <div class="fs-4 fw-bold day-number">{{ day | date:'dd' }}</div>
      </div>
    </div>
  </div>

  <!-- Vista del Día Seleccionado -->
  <div class="row">
    <div class="col-lg-8">
      <div class="card border-0 shadow-sm rounded-16 appointments-card">
        <div class="card-header bg-white py-3 border-0 d-flex justify-content-between align-items-center">
          <h5 class="mb-0 fw-bold">Citas para el {{ selectedDate | date:'fullDate' }}</h5>
          <span class="badge bg-light text-dark border">{{ (appointments$ | async)?.length }} Programadas</span>
        </div>
        
        <div class="card-body p-0 container-visible">
          <!-- Loading State -->
          <div *ngIf="isLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
          </div>

          <!-- Appointment List -->
          <div *ngIf="!isLoading" class="table-responsive">
            <table class="table table-hover align-middle mb-0">
              <thead class="bg-light">
                <tr class="small text-muted">
                  <th class="ps-4">HORA</th>
                  <th>CLIENTE / BICI</th>
                  <th>SERVICIO</th>
                  <th class="text-center">ESTADO</th>
                  <th class="text-end pe-4">ACCIONES</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let app of appointments$ | async">
                  <td class="ps-4 fw-bold text-primary">{{ app.date.toDate() | date:'HH:mm' }}</td>
                  <td>
                    <div class="fw-bold">{{ app.clientName }}</div>
                    <div class="small text-muted">{{ app.bikeDescription }}</div>
                  </td>
                  <td>
                    <span class="badge bg-info-subtle text-info border border-info-subtle">{{ app.serviceType }}</span>
                  </td>
                  <td class="text-center">
                    <div class="dropdown dropdown-status">
                      <button class="btn btn-sm rounded-pill px-3 dropdown-toggle shadow-sm" 
                              [ngClass]="{
                                'btn-primary': app.status === 'Scheduled',
                                'btn-success': app.status === 'Arrived',
                                'btn-danger': app.status === 'Cancelled',
                                'btn-secondary': app.status === 'No Show'
                              }"
                              data-bs-toggle="dropdown" 
                              data-bs-boundary="viewport"
                              aria-expanded="false">
                        {{ app.status === 'Scheduled' ? 'Agendada' : (app.status === 'Arrived' ? 'Recibida' : app.status) }}
                      </button>
                      <!-- CORRECCIÓN: Clases para forzar visibilidad y alineación -->
                      <ul class="dropdown-menu dropdown-menu-end shadow-lg border-0 animate-fade-in" style="z-index: 1060;">
                        <li><h6 class="dropdown-header small text-uppercase">Cambiar Estado</h6></li>
                        <li><a class="dropdown-item" (click)="updateStatus(app, 'Scheduled')"><i class="bi bi-calendar me-2"></i> Agendada</a></li>
                        <li><a class="dropdown-item" (click)="updateStatus(app, 'Arrived')"><i class="bi bi-box-arrow-in-right me-2"></i> Recibida (En Taller)</a></li>
                        <li><hr class="dropdown-divider"></li>
                        <li><a class="dropdown-item text-danger" (click)="updateStatus(app, 'Cancelled')"><i class="bi bi-x-circle me-2"></i> Cancelar Cita</a></li>
                        <li><a class="dropdown-item text-secondary" (click)="updateStatus(app, 'No Show')"><i class="bi bi-person-x me-2"></i> No se presentó</a></li>
                      </ul>
                    </div>
  
                  </td>
                  <td class="text-end pe-4">
                    <button class="btn btn-link text-danger p-0" (click)="deleteApp(app.id!)"><i class="bi bi-trash"></i></button>
                  </td>
                </tr>
                <tr *ngIf="(appointments$ | async)?.length === 0">
                  <td colspan="5" class="text-center py-5 text-muted italic">
                    <i class="bi bi-calendar-x d-block fs-1 mb-2 opacity-25"></i>
                    No hay citas programadas para este día.
                  </td>
                </tr>
              </tbody>
            </table>
        <div class="py-5 d-md-none" *ngIf="(appointments$ | async)?.length === 1"></div>

          </div>
        </div>
      </div>
    </div>

    <!-- Sidebar de Estadísticas Diarias -->
    <div class="col-lg-4">
      <div class="card border-0 shadow-sm rounded-16 bg-white p-4 mb-4">
        <h6 class="text-muted fw-bold text-uppercase small mb-3">Capacidad del Taller</h6>
        <div *ngIf="appointments$ | async as apps">
          <div class="d-flex justify-content-between mb-2">
            <span class="fw-bold">{{ apps.length }} / {{ DAILY_CAPACITY }} Bicicletas</span>
            <span class="small text-muted">{{ (apps.length / DAILY_CAPACITY) | percent }}</span>
          </div>
          <div class="progress mb-3" style="height: 10px;">
            <div class="progress-bar" role="progressbar" 
                 [style.width.%]="(apps.length / DAILY_CAPACITY) * 100"
                 [ngClass]="getCapacityClass(apps.length)"></div>
          </div>
        </div>
      </div>
      
      <!-- Notas del día -->
      
    </div>
  </div>

  <!-- MODAL: AGREGAR CITA -->
  <div class="modal fade" #addAppModal id="addAppModal" tabindex="-1">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content rounded-20 border-0 shadow-lg">
        <div class="modal-header border-0 pb-0">
          <h5 class="fw-bold"><i class="bi bi-calendar-plus me-2 text-primary"></i>Nueva Cita</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <form [formGroup]="appointmentForm" (ngSubmit)="saveAppointment()">
          <div class="modal-body">
            
            <!-- Buscador de Cliente -->
              <div class="mb-3">
              <label class="form-label small fw-bold">Cliente</label>
              <div class="position-relative">
                <div class="input-group">
                  <span class="input-group-text bg-light border-0"><i class="bi bi-search"></i></span>
                  <input type="text" class="form-control border-0 bg-light" placeholder="Buscar por nombre o teléfono..." 
                         [formControl]="clientSearch" [readonly]="!!selectedClient">
                  <button *ngIf="selectedClient" class="btn btn-outline-secondary border-0" type="button" (click)="clearClient()"><i class="bi bi-x"></i></button>
                </div>
                <!-- CORRECCIÓN: Se oculta automáticamente si selectedClient es true -->
                <div *ngIf="!selectedClient && (filteredClients$ | async) as list" class="list-group position-absolute w-100 shadow-lg" style="z-index: 2100;">
                  <button *ngFor="let c of list" type="button" class="list-group-item list-group-item-action py-2" (click)="selectClient(c)">
                    <div class="fw-bold">{{ c.name }}</div>
                    <small class="text-muted">{{ c.phone || 'Sin teléfono' }}</small>
                  </button>
                </div>
              </div>
            </div>

            <!-- Selección de Bicicleta -->
            <div class="mb-3" *ngIf="selectedClient">
              <label class="form-label small fw-bold">Bicicleta</label>
              <select class="form-select border-0 bg-light" formControlName="bikeId">
                <option value="" disabled>Seleccione una bicicleta...</option>
                <option *ngFor="let b of clientBikes$ | async" [value]="b.id">
                  {{ b.brand }} {{ b.model || '' }} - {{ b.color }}
                </option>
              </select>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label small fw-bold">Tipo de Servicio</label>
                <select class="form-select border-0 bg-light" formControlName="serviceType">
                  <option value="Básico">Mantenimiento Ride</option>
                  <option value="Full">Mantenimiento Full</option>
                  <option value="Armado">Armado</option>
                  <option value="Ride">RideWrap</option>
                  <option value="Otros">Otros</option>
                </select>
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label small fw-bold">Hora Estimada</label>
                <input type="time" class="form-control border-0 bg-light" formControlName="time">
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label small fw-bold">Notas o Solicitudes</label>
              <textarea class="form-control border-0 bg-light" rows="2" placeholder="Describa el problema..." formControlName="notes"></textarea>
            </div>

          </div>
          <div class="modal-footer border-0">
            <button type="button" class="btn btn-light rounded-pill px-4" data-bs-dismiss="modal">Cancelar</button>
            <button type="submit" class="btn btn-primary rounded-pill px-4 shadow" [disabled]="appointmentForm.invalid || !selectedClient || isSaving">
              {{ isSaving ? 'Guardando...' : 'Confirmar Cita' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>